module.exports = __webpack_public_path__ + "assets/img/bg_strategy.cf7bd968.png";